{
  "collapse": "Reduzieren",
  "expand": "Erweitern"
}
